module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/title_faq-a428d4d8ff624cd24d2899917ac34f73.svg";